import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
// Embrace the magic of React, where components come to life!
const LoadingBar = ({}) => {
    const [loadingPercentage, setLoadingPercentage] = useState(0);
    useEffect(() => {
        // Start the animation with a delay of 0.3 seconds
        const delay = setTimeout(() => {
            // This function updates the loading percentage
            const updatePercentage = () => {
                setLoadingPercentage(prevPercentage => {
                    if (prevPercentage >= 100) {
                        return 0; // Reset to 0 if it's 100%
                    }
                    else {
                        return prevPercentage + 1; // Increment by 1
                    }
                });
            };
            // Set up an interval to update the percentage
            // Since the animation needs to complete in 2 seconds, calculate the interval rate
            // 100% in 2 seconds means updating the percentage every 20 milliseconds
            const interval = setInterval(updatePercentage, 20); // 20ms interval
            // Clean up the interval and timeout when the component is unmounted
            return () => {
                clearInterval(interval);
                clearTimeout(delay);
            };
        }, 300); // 300ms delay before starting the animation
        // Cleanup function to clear timeout if component unmounts before the delay ends
        return () => clearTimeout(delay);
    }, []);
    return (_jsx("div", { id: "loading-bar-container", children: _jsx("div", { id: "loading-bar", style: { width: `${loadingPercentage}%`, color: "transparent" }, children: "_" }) }));
};
export default LoadingBar;
